import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { applyTheme, type ThemePreference } from "@vd/ui";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { installNavTrail } from "./lib/navTrail";
import { queryClient, router } from "./router";

// Breadcrumbs, Back and the sidebar highlight: the trail rides in history state (ADR 0030).
installNavTrail(router);

import "./styles.css";

// Pages outside the admin shell (sign-in, listen) follow the saved theme from the first paint.
function storedTheme(): ThemePreference {
  try {
    const v = localStorage.getItem("vd-theme");
    if (v === "dark" || v === "light") return v;
  } catch {
    // storage unavailable
  }
  return "system";
}
applyTheme(storedTheme());

async function enableMocks(): Promise<void> {
  // Statically false in production builds, so the mock code is not bundled.
  if (import.meta.env.MODE !== "mock") return;
  const { startMockWorker } = await import("./mocks/browser");
  await startMockWorker();
}

enableMocks().then(() => {
  const el = document.getElementById("root");
  if (!el) throw new Error("Missing #root");
  createRoot(el).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
});
